export default function bookDemoFnHK(
  name: string | undefined,
  phone: string | undefined,
  location: string,
  demoDays: string[],
) {
  return async function (tokenId: string) {
    const preferDemoDays = demoDays.join("%20");

    const response = await fetch(
      `${process.env.REACT_APP_API_URL_BOOKDEMO_HK}/leads/appointment/CUSTOM/submit?source_code=INIA2403POTA&name=${name}&tel=${phone}&location=${location}&prefer_demo_day=${preferDemoDays}`,
      {
        method: "POST",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${tokenId}`,
        },
      },
    );

    if (!response.ok) throw new Error("Network response was not ok");

    return response.json();
  };
}
